
import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getPaiedInvoice, getInvoiceInPortal, setIssueFactorType } from '../apiRequests/transactionRequest'


function* handleGetPaiedInvoice(action) {
    try {
        const response = yield call(getPaiedInvoice, action.params)
        yield put({

            type: types.GET_ALL_PAIED_INVOICE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_ALL_PAIED_INVOICE_ERROR,
            error: error.response,
        })
    }
}

function* handleGetInvoiceInPortal(action) {
    try {
        const response = yield call(getInvoiceInPortal, action.params)
        yield put({

            type: types.GET_INVOCE_IN_PORTAL_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_INVOCE_IN_PORTAL_ERROR,
            error: error.response,
        })
    }
}


function* handleSetIssueFactorType(action) {
    try {
        const response = yield call(setIssueFactorType, action.params)
        yield put({

            type: types.SET_ISSUTYPE_INVOICE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SET_ISSUTYPE_INVOICE_ERROR,
            error: error.response,
        })
    }
}





function* watcherTransactionSaga() {
    yield takeEvery(types.GET_ALL_PAIED_INVOICE_REQUEST, handleGetPaiedInvoice)
    yield takeEvery(types.GET_INVOCE_IN_PORTAL_REQUEST, handleGetInvoiceInPortal)
    yield takeEvery(types.SET_ISSUTYPE_INVOICE_REQUEST, handleSetIssueFactorType)
}

export default watcherTransactionSaga